import type { RichTextDoc } from '@org/model';

export const EMPTY_DOC: RichTextDoc = {
  type: 'doc',
  content: [{ type: 'paragraph', content: [] }],
};

export function isDocEmpty(doc: RichTextDoc): boolean {
  if (!doc.content || doc.content.length === 0) return true;
  return doc.content.every((node) => {
    if (node.type === 'paragraph') {
      return !node.content || node.content.length === 0;
    }
    return false;
  });
}
